export default {
  welcome: 'Bienvenido',
  subtitle: 'Mira lo que ha pasado mientras no estabas',
  recentModelsTitle: 'Mis Modelos Accedidos Recientemente',
  recentModelsLoading: 'Cargando tus modelos recientes...',
  recentModelsEmptyTitle: 'Aún no hay modelos accedidos',
  recentModelsEmptyMessage: 'Los modelos aparecerán aquí a medida que los accedas',
  createdModelsTitle: 'Modelos Creados Recientemente',
  createdModelsLoading: 'Cargando modelos recientes...',
  createdModelsEmptyTitle: 'Aún no hay modelos creados',
  createdModelsEmptyMessage: 'Los modelos aparecerán aquí a medida que se creen',
  onlyMyModels: 'Mostrar solo modelos creados por mí',
  recentPlansTitle: 'Planes Creados Recientemente',
  recentPlansLoading: 'Cargando planes recientes...',
  recentPlansEmptyTitle: 'Aún no hay planes creados',
  recentPlansEmptyMessage: 'Los planes de tus modelos aparecerán aquí',
  onlyMyPlans: 'Mostrar solo planes creados por mí',
  processing: 'Procesando',
  recentEkrmsTitle: 'EKRMs Creados Recientemente',
  recentEkrmsLoading: 'Cargando EKRMs recientes...',
  recentEkrmsEmptyTitle: 'Aún no hay EKRMs creados',
  recentEkrmsEmptyMessage: 'Los EKRMs aparecerán aquí a medida que se creen',
  onlyMyEkrms: 'Mostrar solo EKRMs creados por mí',
  dataUploadTitle: 'Actividad de Carga de Datos',
  dataUploadLoading: 'Cargando archivos subidos recientes...',
  dataUploadEmptyTitle: 'Aún no hay archivos subidos',
  dataUploadEmptyMessage: 'Los archivos aparecerán aquí a medida que se suban',
  onlyMyUploads: 'Mostrar solo archivos subidos por mí',
  dataBrief: 'Resumen de Datos',
  dataTemplate: 'Plantilla de Datos',
  pendingApproval: 'Pendiente de Aprobación',
  approved: 'Aprobado',
  modelProcessTitle: 'Actividad del Proceso del Modelo',
  modelProcessLoading: 'Cargando actividad de etapas reciente...',
  modelProcessEmptyTitle: 'Aún no hay actividad de etapas',
  modelProcessEmptyMessage: 'Las actividades de etapas aparecerán aquí a medida que ocurran',
  onlyMyActivities: 'Mostrar solo mis actividades',
  unknown: 'Desconocido',
  modelTypeAdHoc: 'Ad-Hoc',
  modelTypeCustomStandard: 'Custom Estándar',
  modelTypeCustomEkrm: 'Custom EKRM',
  uploaded: 'Subido',
  activityApproved: 'Aprobado',
  activityReversed: 'Revertido',
  activityUploaded: 'Subido',
  activityFeedback: 'Feedback',
  activityFeedbackReply: 'Respuesta a feedback'
}
